<template>
  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <v-layout wrap>
      <v-flex v-if="banktransferinfo_photo" xs12 class="pa-1">
        <label for="bankTransferInfoPhoto">{{ $t('Bank Transfer Info Photo') }}</label>

        <v-layout>
          <v-flex>
            <div v-if="isEdit" style="max-width: 600px">
              <uploadfile
                v-model="banktransferinfo_photo.contentvalue"
                :height="250"
                @onUploaded="onUploaded"
              ></uploadfile>
            </div>
            <div v-else style="max-width: 600px">
              <template v-if="banktransferinfo_photo.contentvalue">
                <img
                  :src="banktransferinfo_photo.contentvalue"
                  alt
                  class="responsive-img"
                  style="border-radius: 10px"
                />
              </template>
              <template v-else>
                <img
                  src="/static/img/assets/generic/generic_default_thumbnail.png"
                  class="responsive-img"
                  style="border-radius: 10px"
                />
              </template>
            </div>
          </v-flex>
          <v-flex>
            <v-btn
              v-if="isEdit"
              fab
              small
              depressed
              @click="banktransferinfo_photo.contentvalue = ''"
              ><v-icon>delete</v-icon></v-btn
            >
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex v-if="banktransferinfo" xs12 class="pa-1">
        <label for="bankTransferInfo">{{ $t('Bank Transfer Info') }}</label>
        <template v-if="isEdit">
          <div class="form-control">
            <textarea
              v-model="banktransferinfo.contentvalue"
              class="mb-2"
              :placeholder="$t('Bank Transfer Info')"
              style="resize: vertical; min-height: 90px"
              rows="3"
            ></textarea>
          </div>
        </template>
        <template v-else>
          <p class="primary-color">
            <template v-if="banktransferinfo.contentvalue">
              <nl2br
                tag="span"
                :text="banktransferinfo.contentvalue"
                :title="banktransferinfo.contentvalue"
                style="word-wrap: break-word"
              />
            </template>
            <template v-else>-</template>
          </p>
        </template>
      </v-flex>

      <slot></slot>

      <v-flex xs12>
        <div class="text-xs-center" style="margin-bottom: 15px">
          <template v-if="isEdit">
            <v-btn outline color="grey" @click="reset">
              {{ $t('cancel') }}
            </v-btn>
            <v-btn depressed color="primary" @click="saveContent">
              {{ $t('Save') }}
            </v-btn>
          </template>
        </div>
      </v-flex>
    </v-layout>
  </transition>
</template>

<script>
import axios from 'axios'
import api from '@/api'
import config from '@/config'
import uploadfile from '@/components/elements/uploadfile'
import Nl2br from 'vue-nl2br'

export default {
  components: {
    uploadfile,
    Nl2br
  },
  props: ['init', 'isEdit'],
  data: function () {
    return {
      banktransferinfo_photo: undefined,
      banktransferinfo: undefined
    }
  },
  watch: {
    init: function () {
      this.banktransferinfo = Object.assign({}, this.init.banktransferinfo)
      this.cached_banktransferinfo = Object.assign({}, this.init.banktransferinfo)

      this.banktransferinfo_photo = Object.assign({}, this.init.banktransferinfo_photo)

      //cache
      this.cached_banktransferinfo_photo = Object.assign({}, this.init.banktransferinfo_photo)
    }
  },
  created: function () {
    var vm = this
    this.banktransferinfo_photo = Object.assign({}, this.init.banktransferinfo_photo)
    this.banktransferinfo = Object.assign({}, this.init.banktransferinfo)

    //cache
    this.cached_banktransferinfo_photo = Object.assign({}, this.init.banktransferinfo_photo)
    this.cached_banktransferinfo = Object.assign({}, this.init.banktransferinfo)
  },
  methods: {
    reset: function () {
      var vm = this
      this.banktransferinfo_photo = Object.assign({}, this.cached_banktransferinfo_photo)
      this.banktransferinfo = Object.assign({}, this.cached_banktransferinfo)
      vm.$emit('onSave')

      vm.$emit('reset')
    },
    saveContent: function () {
      var vm = this
      vm.sendRequest(this.banktransferinfo_photo)
      vm.sendRequest(this.banktransferinfo)
      this.cached_banktransferinfo_photo = Object.assign({}, this.banktransferinfo_photo)
      this.cached_banktransferinfo = Object.assign({}, this.banktransferinfo)
      vm.$emit('onSave')
    },
    onUploaded: function (image) {
      this.banktransferinfo_photo.contentvalue = image
    },
    sendRequest: function (content, callback) {
      var vm = this
      api.updateConfig(content, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/setting/ecommerce/TransferPayment.vue